const initialState = {
    numberOfCakes: 10,
    numberOfIcecreams: 20
  };

export const bakeryReducer = (state = initialState, action) => {
    switch (action.type) {
      case "BUY_CAKE":
        return {
          ...state, numberOfCakes: state.numberOfCakes - 1
        };
      case "BUY_ICECREAM":
        return {
          ...state, numberOfIcecreams: state.numberOfIcecreams - 1
        };
      default: return state;
    }
  };